<div class="col-lg-12 dialog-title">
    <h1>{{"Schedule" | translate}}</h1>
    <p class="dialog-title__appointment--small">{{appointmentSchedule}}</p>
  </div>
  
  <mat-dialog-content>
    <div class="search-plate-dialog">
      <div class="search-plate-dialog__actions">
        <div class="field">
          <label class="dialog__label">{{"Plate" | translate}}</label>
          <mat-form-field class="dialog__form-field" [floatLabel]="'auto'">
            <input
              matInput
              type="text"
              (input)="toUpperPlateNumber($event)"
              maxlength="12"
              placeholder="HHH123"
              [(ngModel)]="plateNumber"
            />
          </mat-form-field>
        </div>
  
        <div class="icons">
              <span
            class="dialog__tooltip"
            matTooltip="{{'Search' | translate}}"
            matTooltipPosition="above"
            matTool
            matTooltipClass="searchToolTip"
          >
            <button
              class="icon-box icon-box--fill"
              (click)="onSearch()"
              
            >
              <i class="bi bi-search"></i>
            </button>
        </span>
          <span
            class="dialog__tooltip"
            matTooltip="{{'Add' | translate}}"
            matTooltipPosition="above"
            matTool
            matTooltipClass="searchToolTip"
          >
            <button class="icon-box" (click)="onAddCustomer()">
              <i class="bi bi-plus-lg"></i>
            </button>
          </span>
        </div>
      </div>
  
      
     
      <section class="dialog__loading"*ngIf="isLoading">
        <div  class="pulsing" >
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing" >{{ "Loading" | translate }}...</p>
      </section>
      
      <div>     
        <mat-error *ngIf="showError" class="search_error">
        {{"PlateNotFoundToSchedule" | translate}}
      </mat-error></div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="center">
    <button mat-dialog-close class="dialog__button">{{"Cancel" | translate}}</button>
  </mat-dialog-actions>
  